import { format } from 'date-fns';
import * as utils from '../utils/utils.js';

export default class Countdown {
    constructor($scope, $interval, watchService) {
        this.$interval = $interval;
        this.$scope = $scope;
        this.watchService = watchService;
        this.$scope.watchService = this.watchService;
        this.event = this.watchService.event;
        this.$scope.event = this.event;

        this.startDateLocal = format(utils.getDateFromUTCString(this.event.startTime), 'PPP');
        this.counter = this.$interval(() => {
            if (this.event.startTime !== this.watchService.event.startTime) {
                this.startDateLocal = format(
                    utils.getDateFromUTCString(this.event.startTime),
                    'PPP'
                );
            }
            this.event = this.watchService.event;
            this.$scope.event = this.event;
        }, 1000);
    }
}
